module.exports = __webpack_public_path__ + "896f72eae7d9656400f1d39b4d10b75c.png";


//////////////////
// WEBPACK FOOTER
// ./markup/img/blue-bg-elements.png
// module id = 195
// module chunks = 0